var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"col-12"},[_c('h1',[_vm._v("Admin")]),_c('p',[_c('router-link',{attrs:{"to":"/terms-and-conditions"}},[_vm._v(" Terms & Conditions ")])],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }